import type { ClassBoard } from './classes';
import { todayISO } from './dates';

// What a student has already seen on this device, so the nav can put a chalk dot on a section that changed.
const key = (cls: string) => `gs.seen.materials.${cls}`;

export function newestMaterial(board: ClassBoard): string {
  const today = todayISO();
  return board.units
    .flatMap((u) => u.materials.map((m) => m.added))
    .filter((d) => d <= today)
    .sort()
    .pop() ?? '';
}

export function materialsChanged(board: ClassBoard): boolean {
  try {
    const seen = localStorage.getItem(key(board.id)) ?? '';
    return newestMaterial(board) > seen;
  } catch {
    return false;
  }
}

export function markMaterialsSeen(board: ClassBoard) {
  try {
    localStorage.setItem(key(board.id), newestMaterial(board));
  } catch {
    /* nothing to remember */
  }
}

// The first visit of a new day gets the eraser wipe
export function isNewDay(): boolean {
  try {
    const today = todayISO();
    const last = localStorage.getItem('gs.lastDay');
    localStorage.setItem('gs.lastDay', today);
    return last !== null && last !== today;
  } catch {
    return false;
  }
}
